import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { useComparisonMode } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { InitiativeCompletion } from '../../filters/initiative-completion/initiative-completion';
import { InitiativeFocus } from '../../filters/initiative-focus/initiative-focus';
import { InitiativeOverview } from '../../filters/initiative-overview/initiative-overview';
import { KeyMeasuresOverTime } from '../../filters/key-measures-over-time/key-measures-over-time';
import { MeasureComparison } from '../../filters/measure-comparison/measure-comparison';
import { MonthlyAverages } from '../../filters/monthly-averages/monthly-averages';
import { ComparisonMode, MultipleViewMode, ViewMode } from '../../process-analysis.type';

export const FiltersContent = () => {
  const viewMode = useProcessAnalysisStore((state) => state.viewMode);
  const multipleViewMode = useProcessAnalysisStore((state) => state.multipleViewMode);
  const comparisonMode = useComparisonMode();

  if (comparisonMode === ComparisonMode.Single) {
    switch (viewMode) {
      case ViewMode.MeasureComparison:
        return <MeasureComparison />;
      case ViewMode.InitiativeOverview:
        return <InitiativeOverview />;
      case ViewMode.InitiativeCompletion:
        return <InitiativeCompletion />;
      case ViewMode.InitiativeFocus:
        return <InitiativeFocus />;
      default:
        return null;
    }
  }

  if (comparisonMode === ComparisonMode.Multiple) {
    switch (multipleViewMode) {
      case MultipleViewMode.KeyMeasuresOverTime:
        return <KeyMeasuresOverTime />;
      case MultipleViewMode.MonthlyAverages:
        return <MonthlyAverages />;
      default:
        return null;
    }
  }

  return null;
};
